import useCreateGrade from './useCreateGrade'
import useAlert from './useAlert'
import useSubmitBtns from './useSubmitBtns'
import useFormFields from './useFormFields'

export default { useCreateGrade, useFormFields, useAlert, useSubmitBtns }